/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.707
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listHouseCoownerInfo,
	listHouseCoownerInfoInit,
	listHouseCoownerInfoByAuthorizations,
	deleteHouseCoownerInfo
} from '@api/lcf/HouseCoownerInfo';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listHouseCoownerInfo({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseCoownerInfo(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseCoownerInfoByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseCoownerInfoByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listHouseCoownerInfoInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listHouseCoownerInfoInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseCoownerInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseCoownerInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
